import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BxCardComponent, BxCardHeaderComponent, SvgIconComponent } from '@beyonnex/bx-angular-ui';
import { TranslatePipe } from '@ngx-translate/core';
import type { CurrentStateDataPoint } from './current-state-panel.models';

@Component({
  selector: 'bxi-current-state-panel',
  imports: [BxCardComponent, BxCardHeaderComponent, SvgIconComponent, TranslatePipe],
  templateUrl: './current-state-panel.component.html',
  host: { class: 'block' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentStatePanelComponent {
  readonly title = input.required<string>();
  readonly data = input.required<CurrentStateDataPoint[]>();

  /**
   * True when at least one data point carries a sub-label. The sub-label line is then rendered on
   * every column (empty ones reserve space via `min-h`) so values stay aligned; when no data point
   * has one, the line is omitted entirely and the row collapses.
   */
  protected readonly hasSubLabels = computed(() => this.data().some((dataPoint) => !!dataPoint.subLabel));
}
